import React from 'react';
import './PromoBanner.css';

const PromoBanner = () => {
  return (
    <div className="promo-banner">
      <div className="promo-content">
        <h2>
          Everyday<br />
          Low Price
        </h2>
        <button className="promo-button">
          Get 20% off
        </button>
      </div>
    </div>
  );
};

export default PromoBanner; 